module.exports = __webpack_public_path__ + "static/media/Wonka-Party-1.e3a62348.jpg";